export const tableColumn = [
  {
    text:'用券用户手机号',
    value:'phone'
  },
  {
    text:'领券时间',
    value:'createTime'
  },
  {
    text:'天猫券名称',
    value:'name'
  },
  {
    text:'团购券面值',
    value:'originalPrice'
  },
  {
    text:'核销券码',
    value:'couponCode'
  },
  {
    text:'天猫券订单号',
    value:'outerId'
  },
  {
    text:'应收金额',
    value:'sellPrice'
  },
  {
    text:'券使用状态',
    value:'useStatus'
  },
  {
    text:'券退款状态',
    value:'refundStatus'
  },
  {
    text:'用券影票订单号',
    value:'orderId'
  },
  {
    text:'市场价',
    value:'initPrice'
  },
  {
    text:'券后支付价',
    value:'payPrice'
  },
  {
    text:'指导价',
    value:'guidePrice'
  },
  {
    text:'用券时间',
    value:'useCouponTime'
  },
]



// WEBPACK FOOTER //
// ./src/views/pc/miniProgram/couponTaoBao/component/enum.js